import { UserDetails } from "shared/types/UserDetailsTypes";
import { create } from "zustand";

interface UserDetailsState {
  userDetails: UserDetails | null;
  updateUserDetails: (userDetails: UserDetails) => void;
}

export const useUserDetailsStore = create<UserDetailsState>((set) => ({
  userDetails: null,
  updateUserDetails: (userDetails: UserDetails) =>
    set({ userDetails: userDetails }),
}));
